import Button from 'components/controls/Button';
import {
   StyledMessagedButton,
   StyledMessagePage,
   StyledMessagePageContainer,
   StyledMessagePageLogo,
   StyledMessagePageLogoContainer,
   StyledMessagePageText,
   StyledMessagePageTextContainer
} from 'shared/styled/message-page.styled';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NewOpportunitySuccessProps {
   onCreateAnother: () => void;
}

export const NewOpportunitySuccess = ({ onCreateAnother }: NewOpportunitySuccessProps) => {
   const history = useHistory();

   function handleGoodPracticeClick() {
      history.push('/goodpractice/new');
   }

   function handleIssueClick() {
      history.push('/issue/new');
   }

   function handleNearMissClick() {
      history.push('/nearmiss/new');
   }

   return (
      <StyledMessagePageContainer>
         <StyledMessagePage>
            <StyledMessagePageLogoContainer>
               <StyledMessagePageLogo />
            </StyledMessagePageLogoContainer>
            <StyledMessagePageTextContainer>
               <StyledMessagePageText>Thank you for your Near Miss report. This has been submitted for investigation, and to your depot if one was entered.</StyledMessagePageText>
               <StyledMessagePageText>By reporting Near Misses and Good Practices you are helping the business to stay safe.</StyledMessagePageText>
               <StyledMessagePageText>SBR also donate £2 to charity for every Near Miss raised</StyledMessagePageText>
               <StyledMessagePageText>
                  <StyledMessagedButton>
                     <Button text={"New Near Miss"} onClick={handleNearMissClick} />
                  </StyledMessagedButton>
                  <StyledMessagedButton>
                     <Button text={"New Good Practice"} onClick={handleGoodPracticeClick} />
                  </StyledMessagedButton>
                  <StyledMessagedButton>
                     <Button text={"New Issue"} onClick={handleIssueClick} />
                  </StyledMessagedButton>
                  <StyledMessagedButton>
                     <Button text={"New Opportunity"} onClick={onCreateAnother} />
                  </StyledMessagedButton>
               </StyledMessagePageText>
            </StyledMessagePageTextContainer>
         </StyledMessagePage>
      </StyledMessagePageContainer>
   );
};
